import { SkyBoxRoutesEnum } from "models/enums/apiRoutes/skyBoxApiRoutes";
import { IApiBaseResponse } from "models/interfaces/Iglobal";
import axiosClient from "sharedServices/api/axios.services";
export class CompetitorPricesService {
  public getCompetitorPrices = async (competitorPricesDto: {
    event_id: number;
    venue_id: number;
    site_type: string;
    seatmap_url: string;
    force_refresh: boolean;
  }) => {
    return axiosClient.get<IApiBaseResponse>(SkyBoxRoutesEnum.COMPETITOR_PRICES, {
      params: competitorPricesDto
    });
  };

  public getSecondaryMarketplaceMaster = async () => {
    return axiosClient.get<IApiBaseResponse>(
      SkyBoxRoutesEnum.SECONDARY_MARKETPLACE_MASTER
    );
  };
}